import Vue from 'vue'
import { app } from 'src/main.js'

const methods = ['get', 'post', 'put', 'del', 'patch', 'jsonp']
export default class ApiClient {
  baseUrl

  constructor (baseUrl) {
    methods.forEach((method) => {
      this[method] = (url, params = {}, {isNeedAuthor = true, global = true, isManager = false} = {}, opts = {}) => new Promise((resolve, reject) => {
        if (!url) {
          reject({_error: '错误的请求地址'})
        }
        const token = app.$store.state.auth.token
        if (__DEBUG__) {
          Vue.http.headers.common['Authorization'] = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjgwLCJhZ2VudElkIjowLCJzaG9wSWQiOjAsInJhdGUiOjEwLCJ1dHlwZSI6IkIiLCJsZXZlbCI6NSwic2t1QXR0ciI6MSwiaWF0IjoxNTk1MjE1NTAzLCJleHAiOjE1OTUzMDE5MDN9.39TmGOEdLm3SuooAal6Ft4ba8ikceE2suuJ1l8OMY_o'
        }
        if (token) {
          Vue.http.headers.common['Authorization'] = `Bearer ${token}`
        }
        if (!isNeedAuthor) {
          delete Vue.http.headers.common['Authorization']
        }
        params.version = '3.0.0'
        params.platform = 'web'
        Vue.http({
          method: method,
          url,
          [method === 'get' || method === 'jsonp' ? 'params' : 'body']: params,
          global: global,
          ...opts
        }).then((response) => {
          resolve(response.body)
        }).catch((error) => {
          reject(error)
        })
      })
    })
  }
}